
    // Handle protected navigation links
    document.addEventListener('DOMContentLoaded', () => {
      const protectedLinks = document.querySelectorAll('[data-protected]');
      
      protectedLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          
          const token = localStorage.getItem('token') || localStorage.getItem('authToken');
          const targetUrl = link.getAttribute('data-protected');
          
          if (token) {
            // User is logged in, allow navigation
            window.location.href = targetUrl;
          } else {
            // User not logged in, redirect to login with return URL
            window.location.href = `/login.html?redirect=${encodeURIComponent(targetUrl)}`;
          }
        });
      });
    });
  